export default {
  methods: {
    userHasPermissions(elementRoute) {
      // return true;
      const userRoleNames = this.$store.getters.userRoleNames;
      if (
        elementRoute.hasOwnProperty('meta') &&
        elementRoute.meta.hasOwnProperty('allowedRoles') &&
        Array.isArray(elementRoute.meta.allowedRoles)
      ) {
        for (let i = 0; i < elementRoute.meta.allowedRoles.length; i++) {
          const role = elementRoute.meta.allowedRoles[i];
          if (userRoleNames.includes(role) || role === 'all') {
            return true;
          }
        }
      } else {
        return true;
      }
    },

    userCanAccessPath(routePath) {
      // return true;
      const route = this.$router.resolve({
        path: routePath,
      });

      if (!!route && !!route.resolved) {
        return this.userHasPermissions(route.resolved);
      } else {
        return false;
      }
    },

    userHasAnyRole(roleArray) {
      const userRoleNames = this.$store.getters.userRoleNames;
      for (let i = 0; i < roleArray.length; i++) {
        const role = roleArray[i];
        if (userRoleNames.includes(role) || role === 'all') {
          return true;
        }
      }

      return false;
    },

    userOnlyHasRole(roleName) {
      const userRoleNames = this.$store.getters.userRoleNames;

      for (let i = 0; i < userRoleNames.length; i++) {
        const role = userRoleNames[i];
        if (role !== roleName) {
          return false;
        }
      }

      return userRoleNames.includes(roleName);
    },

    userHasActiveModule(elementRoute) {
      let active = true;

      if (elementRoute.hasOwnProperty('meta') && elementRoute['meta'].hasOwnProperty('module')) {
        active =
          this.$store.getters['customerModules'] &&
          this.$store.getters['customerModules'][elementRoute.meta.module];
      }

      return active;
    },
  },
};
